import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const QUERY = gql`
  query PromotionCodeInfo(
    $code: String!
    $plan: String!
    $wordsTier: String
    $billingCycle: String!
    $customerId: ID
  ) {
    promotionCodeInfo(
      code: $code
      plan: $plan
      wordsTier: $wordsTier
      billingCycle: $billingCycle
      customerId: $customerId
    ) {
      durationInMonths
      percentOff
      validTiers
      validPlans
      bonusCredits
      minimumPrice
    }
  }
`;

export const queryPromotionCodeInfo = ({ code, plan, wordsTier, billingCycle, customerId }) =>
  executeGqlQuery({
    query: QUERY,
    variables: {
      code,
      plan,
      wordsTier,
      billingCycle,
      customerId,
    },
  }).then(({ data, errors }) => {
    return { data: getSingleProp(data), error: getSingleProp(errors) };
  });
